import React, { Component } from 'react';
import context from './api/context';
import Snackbar from 'material-ui/Snackbar';
import SubscriptionManager from './SubscriptionManager';

export default class TransactionSnackbar extends Component {

  state = {};

  subs = new SubscriptionManager();

  componentWillMount() {
    context.log.handle('subscribing TransactionSnackbar', async () => {
      const w3 = await context.web3;
      this.subs.subscribeEvent(w3.events, 'tx-send', () => {
        this.setState({
          snackbar: 'Transaction is posting.',
          snackbarTimeout: null
        })
      });
      this.subs.subscribeEvent(w3.events, 'tx-send-error', () => {
        // NOTE: have to clear the snackbar before setting the timeout
        this.setState({
          snackbar: null
        }, () => setTimeout(() => this.setState({
          snackbar: 'There was an error with that transaction',
          snackbarTimeout: 10000
        })))
      });
      this.subs.subscribeEvent(w3.events, 'tx-send-success', (tx) => {
        this.setState({
          snackbar: 'Transaction posted: ' + tx.result,
          snackbarTimeout: null
        })
      });
      this.subs.subscribeEvent(w3.events, 'tx-send-mined', () => {
        // NOTE: have to clear the snackbar before setting the timeout
        this.setState({
          snackbar: null
        }, () => setTimeout(() => this.setState({
          snackbar: 'Transaction mined!',
          snackbarTimeout: 3000
        })))
      })
    })
  }

  componentWillUnmount() {
    this.subs.unsubscribe();
  }

  handleSnackbarClose = (event, reason) => {
    if (reason !== 'clickaway') {
      this.setState({ snackbar: null })
    }
  }

  render() {
    const { snackbar, snackbarTimeout } = this.state;

    return (<Snackbar
              anchorOrigin={{ vertical:'bottom', horizontal:'center' }}
              open={!!snackbar}
              onClose={this.handleSnackbarClose}
              autoHideDuration={snackbarTimeout}
              message={<span id="message-id">{snackbar}</span>}
            />);
  }
}


// WEBPACK FOOTER //
// ./src/TransactionSnackbar.js